import m from "./../../../dist/es2015/locales/fr_FR.js";
export const am5locales_fr_FR = m;